import * as React from 'react';
import {
  Box,
  Backdrop,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Typography,
} from '@mui/material';
import { Share, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function MobileStagger() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: 330,
        transform: 'translateZ(0px)',
        flexGrow: 1,
        position: 'fixed',
        bottom: '3rem',
        right: '1rem',
      }}
    >
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="Mobile Stagger"
        sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        <SpeedDialAction
          key="Change Password"
          icon={<Edit />}
          tooltipTitle={<Typography>Change password</Typography>}
          tooltipOpen
          onClick={() => navigate('/change-password', { replace: false })}
        />
        <SpeedDialAction
          key="Share"
          icon={<Share />}
          tooltipTitle={<Typography>Share</Typography>}
          tooltipOpen
          onClick={handleClose}
        />
      </SpeedDial>
    </Box>
  );
}
